<template>
  <div class="app flex-row">
    <div class="container-fluid">

      <b-row>
        <b-col md="9" class="img-promocion-custom d-none d-md-block" :style="{ backgroundImage: 'url(' + fondo + ')'}">
        </b-col>

        <b-col md="3" class="pl-0 pr-0 container-login-custom">
          <div class="login-content-custom">
            <div class="container-logo-custom">
              <b-img :src="logo" class="logo-custom"/>
            </div>

            <b-card no-body class="mb-0 card-custom">
              <b-card-body class="card-body-custom">

                <b-form class="align-items-center">
                  <h1 class="custom-h1">Acceder</h1>

                  <b-form-group label="Email">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-user"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input type="email" class="form-control" placeholder="Email" autocomplete="email" v-model="form.email" v-on:keyup.enter.native="login"/>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group label="Contraseña">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-input-group-text>
                          <i class="icon-lock"></i>
                        </b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input type="password" class="form-control" placeholder="Password" autocomplete="current-password" v-model="form.password" v-on:keyup.enter.native="login"/>
                    </b-input-group>
                  </b-form-group>

                  <b-row>                
                    <b-col md="12">
                      <b-button variant="primary" class="px-4 submit-custom primary-background" v-on:click="login">ACCEDER</b-button>
                    </b-col>
                  </b-row>                

                  <b-row>                
                    <b-col md="12" class="text-center">
                      <b-button variant="link" class="px-0 primary-color" @click="ir('register')" v-if="parameters.registersUser">Crear Usuario</b-button>
                    </b-col>
                  </b-row>               
                   
                  <b-row>                
                    <b-col md="12" class="text-center">
                      <b-button variant="link" class="px-0 primary-color" @click="ir('recovery')">Olvide mi contraseña</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </div>

          <div v-if="parameters.showClearCacheButton" class="login-footer-custom text-center">
            <b-button variant="link" class="px-0 subtle-clear-cache-button" @click="clearCache">Borrar caché</b-button>
          </div>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import serviceAPI from './services'
  import {EventBus} from '@/handler/event-bus'
  import Helper from '@/handler/helper'
  import Param from '@/config/parameters'
  import Storage from '@/handler/storageSession'
  import StorageLocal from '@/handler/storageLocal'

  export default {
    data () {
      return {
        isOnline: navigator.onLine,
        logo: '',
        fondo: '',
        form: {
          email: '',
          password: '',
        },
        parameters: {
          registersUser: Helper.hasParametersAccess(Param.P1),
          showClearCacheButton: Helper.hasParametersAccess(Param.P74)
        }
      }
    },
    created () {
      EventBus.$on('Settings:settings', () => {
        this.setup()
      })
      EventBus.$on('Parameters:parameters', () => {
        this.setupParameters()
      })
    },
    mounted() {
      this.setup()
      this.setupParameters()
      this.loadParameters()
      window.addEventListener('online', () => { this.isOnline = true })
      window.addEventListener('offline', () => { this.isOnline = false })
    },
    methods: {
      setup () {
        if(Session.getSession().settings) {
          this.logo = Session.getSession().settings.logo
          this.fondo = Session.getSession().settings.image_login
        }
      },
      setupParameters () {
        if(Session.getSession().parameters) {
          this.parameters.registersUser = Helper.hasParametersAccess(Param.P1)
          this.parameters.showClearCacheButton = Helper.hasParametersAccess(Param.P74)
        }
      },
      loadParameters() {
        let loader = this.$loading.show()
        var result = serviceAPI.obtenerParametros()

        result.then((response) => {
          var data = response.data

          Session.setSessionParameters(data);
          loader.hide()
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
          loader.hide()
        });
      },
      ir(path) {
        if(path == 'register') {
          this.$router.push({ name: 'Register' })
        }
        if(path == 'recovery') {
          this.$router.push({ name: 'Recovery' })
        }
      },
      clearCache () {
        this.$router.push({ path: '/auth/clear' })
      },
      async login () {
        let loader = this.$loading.show()
        await serviceAPI
          .login(this.form)
          .then(async (response) => {
            var data = response.data          

            Session.setSessionAuth(data);

            StorageLocal.removeValue('configWidget');
            await serviceAPI
              .obtenerWidget()
              .then((response) => {            
                StorageLocal.setValue('configWidget', JSON.stringify(response.data));
              })

            StorageLocal.removeValue('configWidgetEmployee');
            await serviceAPI
              .obtenerEmpleado()
              .then((response) => {
                StorageLocal.setValue('configWidgetEmployee', JSON.stringify(response.data));
              })

            // suscribe a las notificaciones
            Storage.removeValue('NotificationsSentToServer')
            try {
              require("../../handler/notifications.js")   
            } catch (error) {
              console.log("PWA Notifications disable")
            }          

            this.$router.push({ name: 'Contenedor' })
            loader.hide()
          })
          .catch(error => {
            this.$awn.alert(Error.showError(error))
            loader.hide()
          });
      }
    },
  }
</script>

<style>
  .img-promocion-custom {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100vh;
    width: 100%;
    position: relative;
    z-index: 10;
    background-color: rgba(0,0,0,0.8);
    /*filter: brightness(0.4);*/
  }
  .card-custom {
    width: 100%;
    padding-top: 15%;
    padding-left: 15%;
    padding-right: 15%;
    border: none;
  }
  .card-body-custom {
    padding: 0px;
  }
  .custom-h1{
    font-weight: 100;
  }
  .container-logo-custom{
    padding-left: 15%;
    padding-right: 15%;
    padding-top: 20%;
    background: #ffff;
  }
  .logo-custom{    
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-height: 75px;
    max-width: 100%;
    object-fit: contain;        
  }
  .submit-custom {
    width: 100%;
  }
  .container-login-custom {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background: #ffffff;
  }
  .login-content-custom {
    flex: 1 0 auto;
  }
  .login-footer-custom {
    margin-top: auto;
    padding: 12px 24px 18px;
  }
  .subtle-clear-cache-button {
    color: #7a7a7a;
    font-size: 12px;
    opacity: 0.85;
    text-decoration: none;
  }
  .subtle-clear-cache-button:hover,
  .subtle-clear-cache-button:focus {
    color: #5f5f5f;
    opacity: 1;
    text-decoration: none;
  }
</style>
